import _extends from "@babel/runtime/helpers/extends";
import React, { createContext, useCallback, useState } from 'react';
import { Notification } from './Notification';
import { NotificationNest } from './NotificationNest';
export const NotificationContext = /*#__PURE__*/createContext(null);
export const NotificationProvider = _ref => {
  let {
    children
  } = _ref;
  const [toasts, setToasts] = useState([]);
  const promptNotification = useCallback(_ref2 => {
    let {
      message,
      status,
      duration = 3000
    } = _ref2;
    const key = Math.random().toString(36).substring(2, 15);
    setToasts(prev => [...prev, {
      key,
      children: message,
      status,
      duration
    }]);
  }, []);
  const removeNotification = useCallback(key => {
    setToasts(prev => prev.filter(toast => toast.key !== key));
  }, []);
  return /*#__PURE__*/React.createElement(NotificationContext.Provider, {
    value: {
      promptNotification
    }
  }, /*#__PURE__*/React.createElement(NotificationNest, null, toasts.map(_ref3 => {
    let {
      key,
      ...toastProps
    } = _ref3;
    return /*#__PURE__*/React.createElement(Notification, _extends({
      key: key
    }, toastProps, {
      onDismiss: () => removeNotification(key)
    }));
  })), children);
};
//# sourceMappingURL=NotificationProvider.js.map